import { InlineEditableText } from '@/components/atoms/InlineEditableText';
import { ResourceDisplayNameMaxLength } from '@/constants';

interface ResourceColumnHeaderProps {
  resourceTypeId: string;
  displayName: string;
  isReadOnly: boolean;
  onRename?: (id: string, name: string) => Promise<void>;
}

/**
 * Renamable resource-type column header. Shown on the Resourcing tab and the Resource Cost tab
 * (EWM-738). Falls back to a plain label when read-only or no rename handler is supplied.
 */
export const ResourceColumnHeader = ({
  resourceTypeId,
  displayName,
  isReadOnly,
  onRename,
}: ResourceColumnHeaderProps) => {
  if (isReadOnly || !onRename) {
    return <span>{displayName}</span>;
  }

  // Reuse the same inline editor as Phase/Subphase rename for a consistent UX:
  // click-to-edit, a normal bordered input with confirm/cancel and a char counter.
  return (
    <div className='flex justify-end'>
      <InlineEditableText
        value={displayName}
        onSubmit={(next) => onRename(resourceTypeId, next)}
        maxLength={ResourceDisplayNameMaxLength}
        ariaLabel={`Rename ${displayName}`}
        displayClassName='font-semibold'
        inputClassName='text-right font-semibold'
      />
    </div>
  );
};
